import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { invoiceReceiptDateTime, formatDecimal } from 'utils/formatter';
import styles from './style.css';

class RefundedLoyaltyInfo extends Component {
  render() {
    const { loyalty, memberPhone } = this.props;
    return (
      <div className={`${styles['refunded-loyalty-info']}`}>
        <div>
          <div className={`${styles.title} pull-left`}>Loyalty Program</div>
          <div className="clearfix" />
        </div>
        <div>
          <span className="pull-left">Member Since</span>
          <span className="pull-right">
            {invoiceReceiptDateTime(loyalty.member_since, 'date')}
          </span>
          <span className="clearfix" />
        </div>
        <div>
          <span className="pull-left">Member Number</span>
          <span className="pull-right">{memberPhone}</span>
          <span className="clearfix" />
        </div>
        {!this.props.isUnpaidInvoiceEarningPoints && (
          <div className="top20">
            <div>
              <div className="pull-left">Loyalty Program</div>
              <div className="clearfix" />
              <div className={`${styles['loyalty-info-detail']}`}>
                <div>
                  <span className="pull-left">Current Balance</span>
                  <span className="pull-right">
                    {formatDecimal(loyalty.current_balance)}
                  </span>
                  <span className="clearfix" />
                </div>
                <div>
                  <span className="pull-left">Point Correction</span>
                  <span className="pull-right">
                    {loyalty.point_correction
                      ? `(${formatDecimal(Math.abs(loyalty.point_correction))})`
                      : formatDecimal(Math.abs(loyalty.point_correction))}
                  </span>
                  <span className="clearfix" />
                </div>
                <div>
                  <span className="pull-left">Closing Balance</span>
                  <span className="pull-right">
                    {formatDecimal(loyalty.closing_balance)}
                  </span>
                  <span className="clearfix" />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

RefundedLoyaltyInfo.propTypes = {
  loyalty: PropTypes.object,
};

export default RefundedLoyaltyInfo;
